export default __webpack_public_path__ + "static/media/grogu.337fe234.webp";